import { Component } from '@angular/core';
import { SkeletonComponent } from '@esolutions/design-system-ng/components';

@Component({
  selector: 'app-news-placeholder',
  templateUrl: './news-placeholder.component.html',
  styleUrls: ['./news-placeholder.component.scss'],
  imports: [SkeletonComponent],
  standalone: true
})
export class NewsPlaceholderComponent {}
